import React from "react";
import BuyView from "./buy/BuyView";
import useInitBuyOrReserve from "../../../hooks/buy/useInitBuyOrReserve";

// This is component is necessary because the V1 also has a container to switch between toyota / lexus,
// this means we cannot call useInitBuy inside the view directly.
const BuyContainer = (): JSX.Element => {
    useInitBuyOrReserve();
    return <BuyView />;
};

export default BuyContainer;
